import { useState, useEffect, useCallback } from 'react';
import {
  fetchUnreadCounts,
  MessagerieModule,
  MessagerieAuteurType,
  UnreadCounts,
} from './messagerieUnread';

export type MessageChannel = 'questions_reponses' | 'messagerie';
export type { UnreadCounts, MessagerieModule, MessagerieAuteurType };

// Hook GENERIQUE de comptage des non-lus (badges des onglets Q&R / Messagerie), partage MS + BDC.
// Parametre par module (prefixe API) et role : remplace les hooks acheteur/prestataire dupliques.
// I/O dans le service ; markRead vide le badge LOCALEMENT apres le mark-read serveur declenche par
// TabMessagerie a l'ouverture de l'onglet (pas de refetch, coherent avec l'existant MS).
export const useUnreadCounts = (
  module: MessagerieModule,
  auteurType: MessagerieAuteurType,
  operationId?: number | string,
) => {
  const [counts, setCounts] = useState<UnreadCounts | null>(null);

  useEffect(() => {
    if (!operationId) return undefined;
    let active = true;
    fetchUnreadCounts(module, auteurType, operationId)
      .then((c) => {
        if (active && c) setCounts(c);
      })
      .catch(() => undefined);
    return () => {
      active = false;
    };
  }, [module, auteurType, operationId]);

  const markRead = useCallback((channel: MessageChannel) => {
    setCounts((prev) => {
      if (!prev) return null;
      if (channel === 'questions_reponses' && prev.questions_reponses > 0) {
        return { ...prev, questions_reponses: 0 };
      }
      if (channel === 'messagerie' && prev.messagerie > 0) {
        return { ...prev, messagerie: 0 };
      }
      return prev;
    });
  }, []);

  return { counts, markRead };
};
